import { render } from "./HtmlTabletFormComponentDetails.vue?vue&type=template&id=34d3ffa8"
import script from "./HtmlTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./HtmlTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__